module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">Text</span></div>\r\n<div id=\"propStyleFont\" class=\"style-text prop-detail\"></div>\r\n<div class=\"row\">\r\n	<div id=\"propStyleTextColor\" class=\"col-md-8 style-text\"></div>\r\n	<div id=\"propStyleTextStyle\" class=\"col-md-4 style-text\" style=\"padding-right: 5px;\"></div>\r\n</div>\r\n\r\n\r\n")
  }
  return __output;

}